export default __webpack_public_path__ + "static/media/stopwatch.d70564a5.png";